<div class="card inner-shadow">
    <div class="card-body">
        <div class="header">
            <div class="left-header">
                <p class="title text-left">{{ui?.name}}</p><small>{{ui?.date | date:'yyyy / M / d'}}</small>
            </div>
            <div class="right-header">
                <ng-container *ngFor="let bgUrl of ui?.assignImgs; trackById">
                    <div class="avatar" [style.backgroundImage]="bgUrl"></div>
                </ng-container>
            </div>
        </div>
        <div class="description">
            <p>{{ 'Annotation' | translate }}</p>
            <p>{{input?.annotation?.name}}</p>
        </div>
        <div class="description">
            <p>{{ 'Description' | translate }}</p>
            <p>{{ui?.description}}</p>
        </div>
    </div>
</div>